import React, { useContext, useEffect, useState } from "react";
import { API } from "aws-amplify";
import { Context } from "../../../../Context";
import { PaginatedTable } from "../../../../common/DataDisplay";
import { FaEye } from "react-icons/fa6";
import { Button } from "flowbite-react";
import { getCurrencySymbol } from "../../../../common/Inputs";
import { RiBillLine } from "react-icons/ri";
import { DayPicker } from 'react-day-picker';
import * as XLSX from "xlsx"; 
import { jsPDF } from "jspdf"; 
import "jspdf-autotable"; 
import Error from "../../../Error";
import OrderDetailsModal from "./OrderDetailsModal";
import PrintOrderHistoryBill from "./PrintOrderHistoryBill";

const OrderHistory = () => {
  const { institution } = useContext(Context).institutionData;
   const { institutionData } = useContext(Context);
 const [selectedOrderItems, setSelectedOrderItems] = useState([]);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [orders, setOrders] = useState([]);
  const { userData } = useContext(Context);
  const [ loader, setLoader ] = useState(true);
  const [modalOrder, setModalOrder] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [staffList, setStaffList] = useState([]);
  const [chefNames, setChefNames] = useState({});
  const [showKOT, setShowKOT] = useState(false);
  const [kotOrderId, setKotOrderId] = useState(null);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [showStartDatePicker, setShowStartDatePicker] = useState(false);
  const [showEndDatePicker, setShowEndDatePicker] = useState(false);
  const [showDayPicker, setShowDayPicker] = useState(false);
  const [filterType, setFilterType] = useState("day"); 
  const [selectedDate, setSelectedDate] = useState(new Date()); 
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date()); 
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth()); 
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); 
  const [showPrintBill, setShowPrintBill] = useState(false); 
  const [selectedPrintOrder, setSelectedPrintOrder] = useState(null);
  if (userData?.userType !== 'admin') {
    return <Error message="Access Denied: Admins Only" />;
  }

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getOrders();
  }, [institution, userData, filterType, selectedDate, startDate, endDate, selectedMonth, selectedYear]);

  const getOrders = async () => {
    if (!userData || !userData.userType || !userData.cognitoId) {
      console.log("Waiting for userData to load...");
      return;
    }
    try {
      setLoader(true);
      const result = await API.get(
        "main",
        `/admin/list-orders/${institution}`,
        {}
      );
      console.log("Fetched orders:", result);

      let filteredOrders = result.filter((order) => order.paymentStatus === true);

      if (filterType === "day") {
        const dayStart = new Date(selectedDate);
        dayStart.setHours(0, 0, 0, 0);
        const dayEnd = new Date(selectedDate);
        dayEnd.setHours(23, 59, 59, 999);

        filteredOrders = filteredOrders.filter((order) => {
          const orderDate = new Date(order.createdAt);
          return orderDate >= dayStart && orderDate <= dayEnd;
        });
      } else if (filterType === "dateRange") {
        const start = new Date(startDate);
        start.setHours(0, 0, 0, 0);
        const end = new Date(endDate);
        end.setHours(23, 59, 59, 999);

        filteredOrders = filteredOrders.filter((order) => {
          const orderDate = new Date(order.createdAt);
          return orderDate >= start && orderDate <= end;
        });
      } else if (filterType === "monthly") {
        filteredOrders = filteredOrders.filter((order) => {
          const orderDate = new Date(order.createdAt);
          return (
            orderDate.getMonth() === selectedMonth &&
            orderDate.getFullYear() === selectedYear
          );
        });
      } else if (filterType === "yearly") {
        filteredOrders = filteredOrders.filter((order) => {
          const orderDate = new Date(order.createdAt);
          return orderDate.getFullYear() === selectedYear;
        });
      }
      const sortedOrders = filteredOrders.sort(
        (a, b) => b.createdAt - a.createdAt
      );

      setOrders(sortedOrders);

      if (userData.userType === "admin") {
        const staffResult = await API.get(
          "main",
          `/admin/staff-list/${institution}`,
          {}
        );
        setStaffList(staffResult);

        const chefNameMapping = {};
        staffResult.forEach((staff) => {
          chefNameMapping[staff.cognitoId] = staff.userName;
        });
        setChefNames(chefNameMapping);
      }
      setLoader(false);
    } catch (e) {
      console.error("Error fetching orders:", e);
      setLoader(false);
    }
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  };

  const netRevenue = orders.reduce((sum, order) => sum + order.totalAmount, 0);
  const totalOrders = orders.length;
  const avgOrderSize = totalOrders > 0 ? (netRevenue / totalOrders).toFixed(2) : 0;

  const handleOrderSelection = (orderId) => {
    setSelectedOrders((prevSelected) =>
      prevSelected.includes(orderId)
        ? prevSelected.filter((id) => id !== orderId)
        : [...prevSelected, orderId]
    );
  };

  const handleSelectAll = () => {
    if (selectedOrders.length === orders.length) {
      setSelectedOrders([]);
    } else {
      setSelectedOrders(orders.map((order) => order.orderId));
    }
  };

  const handlePrintBill = (order) => {
    setSelectedPrintOrder(order);
    setShowPrintBill(true);
  };

  const exportToExcel = () => {
    const selectedData = orders.filter((order) =>
      selectedOrders.includes(order.orderId)
    );

    const exportData = [];
    
    selectedData.forEach((order) => {
      const mainOrderRow = {
        "Order ID": order.orderId,
        "Name": order.name,
        "Table": order.tableName,
        "Phone Number": institution === "bhuk2323" ? order.phoneNumber || "N/A" : "",
        "Payment Method": order.paymentMethod,
        "Total Amount": `${getCurrencySymbol(order.currency)}${order.totalAmount}`,
        "Date": formatDate(order.createdAt),
        "Item Name": "",
        "Quantity": "",
        "Item Price": "",
        "Item Total": ""
      };
      exportData.push(mainOrderRow);

      if (order.items && order.items.length > 0) {
        order.items.forEach((item) => {
          exportData.push({
            "Order ID": "",
            "Name": "",
            "Table": "",
            "Phone Number": "",
            "Payment Method": "",
            "Total Amount": "",
            "Date": "",
            "Item Name": item.name,
            "Quantity": item.quantity,
            "Item Price": `${getCurrencySymbol(order.currency)}${item.price}`,
            "Item Total": `${getCurrencySymbol(order.currency)}${item.price * item.quantity}`
          });
        });
      }

      exportData.push({
        "Order ID": "",
        "Name": "",
        "Table": "",
        "Phone Number": "",
        "Payment Method": "",
        "Total Amount": "",
        "Date": "",
        "Item Name": "",
        "Quantity": "",
        "Item Price": "",
        "Item Total": ""
      });
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

    const maxWidth = 50;
    const colWidths = {};
    Object.keys(exportData[0]).forEach(key => {
      colWidths[key] = Math.min(
        Math.max(...exportData.map(row => row[key] ? row[key].toString().length : 0)),
        maxWidth
      );
    });
    worksheet["!cols"] = Object.keys(colWidths).map(key => ({ wch: colWidths[key] }));

    XLSX.writeFile(workbook, "orders_with_items.xlsx");
  };

  const exportToPDF = () => {
    const selectedData = orders.filter((order) =>
      selectedOrders.includes(order.orderId)
    );
  
    const doc = new jsPDF();
    let yPos = 20;
    const pageWidth = doc.internal.pageSize.width;
    
    selectedData.forEach((order, index) => {
      if (yPos > 250) {
        doc.addPage();
        yPos = 20;
      }

      doc.setFontSize(12);
      doc.setFont(undefined, 'bold');
      doc.text(`Order Details - ${order.orderId}`, 10, yPos);
      yPos += 10;

      doc.setFontSize(10);
      doc.setFont(undefined, 'normal');
      doc.text(`Customer: ${order.name}`, 10, yPos);
      doc.text(`Table: ${order.tableName}`, 80, yPos);
      doc.text(`Date: ${formatDate(order.createdAt)}`, 150, yPos);
      yPos += 7;
      if (institution === "bhuk2323") {
        doc.text(`Phone: ${order.phoneNumber || "N/A"}`, 10, yPos);
        yPos += 7;
      }
      doc.text(`Payment Method: ${order.paymentMethod}`, 10, yPos);
      doc.text(`Total Amount: ${order.totalAmount}`, 80, yPos);
      yPos += 10;

      if (order.items && order.items.length > 0) {
        doc.autoTable({
          startY: yPos,
          head: [["Item Name", "Quantity", "Price", "Total"]],
          body: order.items.map((item) => [
            item.name,
            item.quantity,
            `${item.price}`,
            `${item.price * item.quantity}`
          ]),
          margin: { left: 10 },
          tableWidth: 190
        });
        
        yPos = doc.lastAutoTable.finalY + 20;
      }

      if (index < selectedData.length - 1) {
        doc.setDrawColor(200);
        doc.line(10, yPos - 10, pageWidth - 10, yPos - 10);
        yPos += 10;
      }
    });
    
    doc.save("orders_with_items.pdf");
  };
  
  const head = [
    <div className="flex items-center">
      <input
        type="checkbox"
        checked={selectedOrders.length === orders.length}
        onChange={handleSelectAll}
        className="mr-2"
      />
      Select
    </div>,
    "Sl No",
    "Order ID",
    "Name",
    institution === "bhuk2323" ? "Phone Number" : null,
    "Table",
    "Payment Method",
    "Amount",
    "Date",
    "Actions"
  ]; 
  
  const openOrderDetails = (order) => {
    setSelectedOrderItems(order.items || []);
    setShowOrderModal(true);
  };
  
  const closeOrderModal = () => {
    setShowOrderModal(false);
    setSelectedOrderItems([]);
  };

  const Loader = () => (
    <div className="flex flex-col items-center justify-center p-12">
      <div className="relative">
        <div className="w-16 h-16 border-4 border-gray-300 border-t-primaryColor rounded-full animate-spin"></div>
        <div className="absolute inset-0 flex items-center justify-center font-bold text-xl text-primaryColor">📦</div>
      </div>
      <p className="mt-4 text-primaryColor font-medium">Loading orders...</p>
    </div>
  );

  if (loader) {
    return <Loader />;
  }

  return (
    <>
      <div className="w-full p-8 bg-gray-100">
        <h1 className="max478:text-[22px] text-5xl mb-8">Orders History</h1>

        <div className="flex flex-wrap gap-4 mb-4">
          <div className="flex-1 bg-gradient-to-r from-blue-500 to-blue-600 p-6 rounded-lg shadow-md text-white">
            <h3 className="text-lg font-semibold">Net Revenue</h3>
            <p className="text-2xl">₹{netRevenue}</p>
          </div>
          <div className="flex-1 bg-gradient-to-r from-green-500 to-green-600 p-6 rounded-lg shadow-md text-white">
            <h3 className="text-lg font-semibold">Total Orders</h3>
            <p className="text-2xl">{totalOrders}</p>
          </div>
          <div className="flex-1 bg-gradient-to-r from-purple-500 to-purple-600 p-6 rounded-lg shadow-md text-white">
            <h3 className="text-lg font-semibold">Avg Order Size</h3>
            <p className="text-2xl">₹{avgOrderSize}</p>
          </div>
        </div>

        <div className="flex flex-wrap gap-4 mb-4 bg-white p-4 rounded-lg shadow-md">
          <div className="flex items-center gap-2">
            <label className="text-gray-700">Filter By:</label>
            <select
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              className="border rounded p-2"
            >
              <option value="day">Day</option>
              <option value="dateRange">Date Range</option>
              <option value="monthly">Monthly</option>
              <option value="yearly">Yearly</option>
              <option value="showAll">Show All</option>
            </select>
          </div>

          {filterType === "day" && (
            <div className="relative">
              <div className="flex items-center gap-2">
                <label className="text-gray-700">Select Date:</label>
                <button
                  onClick={() => setShowDayPicker(!showDayPicker)}
                  className="border rounded p-2 bg-white"
                >
                  {selectedDate.toLocaleDateString()}
                </button>
              </div>
              {showDayPicker && (
                <div className="absolute z-10 mt-1 bg-white shadow-lg rounded-lg">
                  <DayPicker
                    mode="single"
                    selected={selectedDate}
                    onSelect={(date) => {
                      setSelectedDate(date || new Date());
                      setShowDayPicker(false);
                    }}
                    className="p-3"
                  />
                </div>
              )}
            </div>
          )}

          {filterType === "dateRange" && (
            <div className="flex items-center gap-2">
              <div className="relative">
                <label className="text-gray-700">Start Date:</label>
                <button
                  onClick={() => setShowStartDatePicker(!showStartDatePicker)}
                  className="border rounded p-2 bg-white ml-2"
                >
                  {startDate.toLocaleDateString()}
                </button>
                {showStartDatePicker && (
                  <div className="absolute z-10 mt-1 bg-white shadow-lg rounded-lg">
                    <DayPicker
                      mode="single"
                      selected={startDate}
                      onSelect={(date) => {
                        setStartDate(date || new Date());
                        setShowStartDatePicker(false);
                      }}
                      className="p-3"
                    />
                  </div>
                )}
              </div>

              <div className="relative">
                <label className="text-gray-700">End Date:</label>
                <button
                  onClick={() => setShowEndDatePicker(!showEndDatePicker)}
                  className="border rounded p-2 bg-white ml-2"
                >
                  {endDate.toLocaleDateString()}
                </button>
                {showEndDatePicker && (
                  <div className="absolute z-10 mt-1 bg-white shadow-lg rounded-lg">
                    <DayPicker
                      mode="single"
                      selected={endDate}
                      onSelect={(date) => {
                        setEndDate(date || new Date());
                        setShowEndDatePicker(false);
                      }}
                      className="p-3"
                      fromDate={startDate}
                    />
                  </div>
                )}
              </div>
            </div>
          )}

          {filterType === "monthly" && (
            <div className="flex items-center gap-2">
              <label className="text-gray-700">Month:</label>
              <select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
                className="border rounded p-2"
              >
                {Array.from({ length: 12 }, (_, i) => (
                  <option key={i} value={i}>
                    {new Date(0, i).toLocaleString("default", { month: "long" })}
                  </option>
                ))}
              </select>
              <label className="text-gray-700">Year:</label>
              <select
                value={selectedYear}
                onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                className="border rounded p-2"
              >
                {Array.from({ length: 10 }, (_, i) => (
                  <option key={i} value={new Date().getFullYear() - i}>
                    {new Date().getFullYear() - i}
                  </option>
                ))}
              </select>
            </div>
          )}

          {filterType === "yearly" && (
            <div className="flex items-center gap-2">
              <label className="text-gray-700">Year:</label>
              <select
                value={selectedYear}
                onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                className="border rounded p-2"
              >
                {Array.from({ length: 10 }, (_, i) => (
                  <option key={i} value={new Date().getFullYear() - i}>
                    {new Date().getFullYear() - i}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="flex items-center gap-2">
            <Button
              onClick={exportToExcel}
              disabled={selectedOrders.length === 0}
              className="bg-green-500"
            >
              Export to Excel
            </Button>
            <Button
              onClick={exportToPDF}
              disabled={selectedOrders.length === 0}
              className="bg-blue-500"
            >
              Export to PDF
            </Button>
          </div>
        </div>

        {orders.length === 0 ? (
          <div className="text-center text-gray-600">No data available</div>
        ) : screenWidth > 1025 ? (
          <PaginatedTable
            head={head}
            data={orders.map((obj, index) => [
              <input
                type="checkbox"
                checked={selectedOrders.includes(obj.orderId)}
                onChange={() => handleOrderSelection(obj.orderId)}
              />,
              index + 1,
              obj.orderId, 
              obj.name,
              institution === "bhuk2323" ? obj.phoneNumber || "N/A" : null, 
              obj.tableName,
              obj.paymentMethod, 
              `₹${obj.totalAmount}`, 
              formatDate(obj.createdAt), 
              <div className="flex gap-2">
                <Button
                  onClick={() => openOrderDetails(obj)}
                  className="bg-primaryColor"
                >
                  <FaEye />
                </Button>
                {institution === "bhuk2323" && (
                  <Button
                    onClick={() => handlePrintBill(obj)}
                    className="bg-blue-500"
                  >
                    <RiBillLine />
                  </Button>
                )}
              </div>,
            ])} 
            rowClassName={(index) =>
              selectedOrders.includes(orders[index].orderId) ? "bg-blue-100" : ""
            }
          />
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
            <div className="col-span-full">
              <Button onClick={handleSelectAll} className="bg-blue-500">
                {selectedOrders.length === orders.length ? "Deselect All" : "Select All"}
              </Button>
            </div>

            {orders.map((order) => (
              <div
                key={order.orderId}
                className={`relative rounded-lg shadow-lg overflow-hidden p-4 flex flex-col justify-between h-full ${
                  selectedOrders.includes(order.orderId)
                    ? "bg-blue-100"
                    : "bg-white"
                }`}
              >
                <div className="flex justify-between items-center mb-1">
                  <h2 className="text-lg font-semibold text-gray-800">
                    {order.name}
                  </h2>
                  <div className="flex space-x-2">
                    <button
                      onClick={() => openOrderDetails(order)}
                      className="text-primaryColor text-lg"
                    >
                      <FaEye />
                    </button>
                    {institution === "bhuk2323" && (
                      <button
                        onClick={() => handlePrintBill(order)}
                        className="text-blue-500 text-lg"
                      >
                        <RiBillLine />
                      </button>
                    )}
                  </div>
                </div>
                <div className="flex justify-between text-sm text-gray-600 mb-2">
                  <div>
                    <span className="font-semibold text-xs">Table:</span>{" "}
                    {order.tableName}
                  </div>
                  <div>
                    <span className="text-xs font-semibold">Total Amount:</span>{" "}
                    ₹{order.totalAmount}
                  </div>
                </div>
                {institution === "bhuk2323" && (
                  <div className="text-xs text-gray-600 mb-2">
                    <span className="font-semibold">Phone:</span>{" "}
                    {order.phoneNumber || "N/A"}
                  </div>
                )}
                {userData.userType === "admin" && order.chefId && (
                  <div className="text-xs text-gray-600 mb-2">
                    <span className="font-semibold">Chef:</span>{" "}
                    {chefNames[order.chefId]
                      ? chefNames[order.chefId]
                      : "Chef Not Found"}
                  </div>
                )}
                <div className="flex justify-between items-center mb-2">
                  <div
                    className={`${
                      order.status === "ready"
                        ? "bg-green-500"
                        : order.status === "pending"
                        ? "bg-red-500"
                        : order.status === "preparing"
                        ? "bg-blue-500"
                        : order.status === "delivered"
                        ? "bg-purple-500"
                        : "bg-gray-500"
                    } text-white text-xs font-semibold px-3 py-1 rounded-full`}
                  >
                    {order.status}
                  </div>
                  <div className="text-xs text-gray-600">
                    <span className="font-semibold">Date:</span>{" "}
                    <span className="font-bold">
                      {formatDate(order.createdAt)}
                    </span>
                  </div>
                </div>
                <input
                  type="checkbox"
                  checked={selectedOrders.includes(order.orderId)}
                  onChange={() => handleOrderSelection(order.orderId)}
                  className="absolute top-4 left-4"
                />
              </div>
            ))}
          </div>
        )}
        
        <OrderDetailsModal
          show={showOrderModal}
          onClose={closeOrderModal}
          orderItems={selectedOrderItems}
        />
        {showPrintBill && selectedPrintOrder && (
          <PrintOrderHistoryBill
            order={{
              orderId: selectedPrintOrder.orderId,
              tableName: selectedPrintOrder.tableName,
              items: selectedPrintOrder.items || [],
              createdAt: selectedPrintOrder.createdAt,
              phoneNumber: institution === "bhuk2323" ? selectedPrintOrder.phoneNumber || "N/A" : undefined
            }}
            institutionData={institutionData}
            screenWidth={screenWidth}
            onClose={() => setShowPrintBill(false)}
          />
        )}
      </div>
    </>
  );
};

export default OrderHistory;